import { Localization } from "OW.Remoting/Remoting/Localization";
import { DateTimeFormatObject, DateUtils } from "../../Global/Base/Utils/DateUtils";
import { CultureInfo } from "../../Global/Dom/CultureInfo";
import { createElement, registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { EditableControl } from "./EditableControl";

export class DateEdit extends EditableControl {
    //#region Fields
    private _placeholderLocKey: string;
    /** pretypovani InnerElementu z predka. InnerElement je element zobrazeny uzivateli, fakeInput je pomocny input v pozadi pro zajisteni spravne funkcionality. */
    protected override _innerElement: HTMLInputElement;
    /** fakeInput - bud je to skryty nativni date input, pomoci ktereho se zobrazuje nativni kalendar,
     * nebo je to skryty input typu text, na ktery se navaze jQuery Datepicker. Picker totiz omezuje zadavane znaky jen na dany format data, ale pozadavek je, aby mohlo byt oddelovacem cokoliv. */
    protected _fakeInput: HTMLInputElement;
    protected _calPicker: HTMLElement;

    //#region Localizations
    //#endregion Localizations
    /**Pomocná proměnná, pokud proběhne inicializace statických prvků, nastaví se true*/
    private static _initializedDate = false;
    private static _fmtFunc: DateTimeFormatObject;
    // @ts-ignore // 23.4.2018 nečteno, ale prozatím ponecháno
    private static culture: string; // jmeno kultury
    private static _fmtRe = /(d+|m+|y+)([^dmy]+)(d+|m+|y+)([^dmy]+)(d+|m+|y+)([^dmy]*)/i; //  regex ktery z ShortDate formatu izoluje oddelovace + format dnu/mesicu (d nebo dd)
    private static _dateinputRe = /^(\d{4})-(\d{1,2})-(\d{1,2})$/; // regex pro input typu date, ten vraci vzdy ve formatu yyyy-mm-dd
    // regexy, vraci 6 skupin - 1. je den, 2. a 3. je mesic a den (v lib. poradi), 4. 5. a 6. jsou den, mesic a rok podle poradi v aktualni kulture
    private static _noSepDmy = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2})(\d{2})(\d{2}|\d{4}))$/; // d | dm | dmy
    private static _noSepDym = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2})(\d{2}|\d{4})(\d{2}))$/; // d | dm | dym
    private static _noSepYmd = /^(?:(\d{1,2})|(\d{2})(\d{2})|(\d{2}|\d{4})(\d{2})(\d{2}))$/; // d | dm | ymd
    private static _sepDmy = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]+(\d{2}|\d{4})[^\d]*)$/; // d. | d.m. | d.m.y.
    private static _sepDym = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{2}|\d{4})[^\d]+(\d{1,2})[^\d]*)$/; // d. | d.m. | d.y.m.
    private static _sepYmd = /^(?:(\d{1,2})[^\d]*|(\d{1,2})[^\d]+(\d{1,2})[^\d]*|(\d{2}|\d{4})[^\d]+(\d{1,2})[^\d]+(\d{1,2})[^\d]*)$/; // d. | d.m. | y.m.d.

    private static _fmtOrder: string; // TODO: udelat z toho static? (+ prislusne metody)

    //Listeners
    private _listenerFakeChange: EventListener;
    private _listenerFakeFocus: EventListener;
    private _listenerPickerClick: EventListener;
    private _listenerChange: EventListener;

    protected _originalValue: Date;
    //#endregion Fields

    public override set value(val: any) {
        let finalValue: any = val;
        if (val instanceof Date) {
            finalValue = val;
        } else if (typeof val === "string") {
            const dateVal = new Date(val);
            if (!isNaN(dateVal.getTime()))
                finalValue = dateVal;
        }

        this.controlValue = finalValue;
    }

    public override get value(): any {
        //return this.originalValue ? this.originalValue.toLocaleDateString() : "";
        return this.controlValue;
    }

    public get controlValue(): Date /*Date*/ {
        if (!this._fakeInput.value)
            return null;
        const val = DateEdit._dateinputRe.exec(this._fakeInput.value);
        if (!val || !DateEdit.checkDate(+val[1], +val[2], +val[3]))
            return null;

        let result = new Date(+val[1], (+val[2]) - 1, +val[3], 0, 0, 0);
        if (this._originalValue)
            result = DateUtils.unionDateAndTime(result, this._originalValue);
        return result;
    }

    /**vstupuje sem OW.Remoting.OWDate nebo js Date, pokud je pouzito pro typ DateTime z DB/AS*/
    public set controlValue(val: Date /*OW.Remoting.OWDate nebo js Date */) {
        if (val !== undefined && val !== null && val instanceof Date) {
            this._originalValue = val;
            this._formatDateAndSetValues(val.getFullYear(), (val.getMonth() + 1), val.getDate(), false);
        } else {
            this._originalValue = null;
            this._fakeInput.value = "";
            this._innerElement.value = "";
            this.setValid();
        }
    }

    /** Vratí hodnotu, kterou reálně zadal uživatel bez ohledu na to, zda je validní či nikoli */
    public get userValue(): string {
        return this._innerElement.value;
    }

    public get placeholderLocKey(): string {
        return this._placeholderLocKey;
    }

    public set placeholderLocKey(value: string) {
        this._placeholderLocKey = value;
        if (this._innerElement) {
            if (value) {
                Localization.addLocTxtData(this._innerElement, this.placeholderLocKey, "placeholder");
                return;
            }
            Localization.remLocData(this._innerElement);
        }
    }

    protected static override get observedAttributes(): string[] {
        return ["culture"].concat(EditableControl.observedAttributes);
    }

    protected override _constructor(): void {
        super._constructor();

        this.initStaticFields();
        // komponenta si registruje vlastni listener (this.InnerElement.addEventListener('change', ...)
        //this.shadowRoot = (this as any).createShadowRoot();
        this.classList.add("DateEdit", "DatesEdits", "native");
        this._innerElement = createElement({ type: "input", attrs: { "type": "tel" } }) as HTMLInputElement;
        this._innerElement.setAttribute("autocomplete", "off");

        this._fakeInput = DateEdit.createFakeInput();

        // TODO: (Firefox 115ESR) Odstranit až bude námi nastavena minimální podporovaná verze Firefoxu 115 ESR nebo vyšší
        // V současné chvíli používáme minimální verzi 102ESR, ale Firefox od verze 109 sjednotil vykresleni DateEditu
        // s ostatnima prohlizecama, takze az bude nova minimalni podporovana verze 115ESR a dal, je to mozne zrusit
        if (document.documentElement.classList.contains("firefox")) {
            const fVersion = parseInt(navigator.userAgent.replace(/.*Firefox\/([0-9].+)$/, "$1"));
            if (fVersion < 109) {
                this.classList.add("firefox-version-less-than-108");
            }
        }

        this._calPicker = this._createValuePicker();

        DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d", this.culture);
        if (this.culture) {
            this.controlValue = this.controlValue;
        }
        this.composeElements();
    }

    // You can also define the other lifecycle methods.
    protected override connectedCallback(): void {
        super.connectedCallback();
        this._setListeners();
    }

    protected override disconnectedCallback(): void {
        super.disconnectedCallback();
        this.dispose();
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "culture":
                this._culture = newVal;
                DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d", newVal);
                this.controlValue = this.controlValue;

                break;
        }
    }

    public initStaticFields(): void {
        if (DateEdit._initializedDate)
            return;
        DateEdit._initializedDate = true;

        DateEdit._fmtFunc = DateUtils.getDateToStringFunction("d");
        DateEdit.culture = CultureInfo.getCultureInfo().name;

        DateEdit.initFmtOrder(); // nastaveni aktualniho formatu data
    }
    //#region Methods

    public override validate(): boolean {
        if (this._innerElement.value) {
            this.parseAndValidateUserInput(false);
        } else if (!this._fakeInput.value) {
            this.setValid();
        } else {
            const val = DateEdit._dateinputRe.exec(this._fakeInput.value);
            const valid = !!val && DateEdit.checkDate(+val[1], +val[2], +val[3]);
            if (valid)
                this.setValid();
            else
                this._showError();
        }
        return this.isValid;
    }

    //#region Must implement from DateEditParents
    public static createFakeInput(): HTMLInputElement {
        return createElement({ type: "input", classes: "fakeinput", attrs: { "tabindex": "-1" } }) as HTMLInputElement;
    }

    public setOtherProperties(): void {
        this._innerElement.type = "tel";
        this._innerElement.maxLength = 20;
    }

    public composeElements(): void {
        this._fakeInput.type = "date";
        this.appendChild(this._fakeInput);
        this.appendChild(document.createElement("br")); // TODO - kvuli errDiv? - zjistit
        this.appendChild(this._innerElement);
        this.appendChild(this._calPicker);
    }
    //#endregion Inherited from DateEditParents

    /**nastavi format data podle aktualni lokalizace*/
    public static initFmtOrder(): void {
        const res = DateEdit._fmtRe.exec(CultureInfo.getStandardDateTimeFormat("d"));
        DateEdit._fmtOrder = "";
        for (let i = 1; i < 6; i += 2) {
            if (/d/i.test(res[i])) {
                DateEdit._fmtOrder += "d";
            } else if (/m/i.test(res[i])) {
                DateEdit._fmtOrder += "m";
            } else if (/y/i.test(res[i])) {
                DateEdit._fmtOrder += "y";
            }
        }
    }

    protected _listenerFocus(): void {
        if (this.enabled && this.validate())
            this._innerElement.value = DateEdit._formatDate(this._fakeInput.value); // zformatuje v aktualni kulture
    }

    protected _setListeners(): void {
        this._fakeInput.addEventListener("change", this._listenerFakeChange = () => {
            this._innerElement.value = DateEdit._formatDate(this._fakeInput.value);
            this.setValid(); // po nastaveni z naseptavace se nastavi jako validni
        });

        this._fakeInput.addEventListener("focusin", this._listenerFakeFocus = (e) => {
            e.stopPropagation();
        });

        this.addEventListener("focusin", this._listenerFocus.bind(this));

        this._innerElement.addEventListener("change", this._listenerChange = () => {
            this.parseAndValidateUserInput(true);
        });

        this._calPicker.addEventListener("click", this._listenerPickerClick = () => {
            (this._fakeInput as any).showPicker();
        });
    }

    // ziska datum z uzivatelem psaneho textu, zvaliduje, zformatuje
    public parseAndValidateUserInput(triggerEvent: boolean): void {
        let val = this._innerElement.value;
        if (!val) {
            this._fakeInput.value = this._innerElement.value = "";
            this.setValid();
            //this.ValueChanged.trigger(this, { Sender: this });
            this.callEvent("change", undefined, false, true);
            return;
        }

        val = val.replace(/\u200E/g, ""); //Unicode Character 'LEFT-TO-RIGHT MARK' - je vlozen pred kazdym cislem po zavolanim Date.toLocaleString

        const rexes = DateEdit._getRexes(); // ziskani regexu
        const res: RegExpExecArray = rexes.noSep.exec(val) || rexes.sep.exec(val); // zkontrolovani data

        if (val && !res) { // nevalidni format data
            this._showError();
            return;
        }

        if (res[1]) { // zadan den
            const today = new Date();
            this._formatDateAndSetValues(today.getFullYear(), today.getMonth() + 1, +res[1], triggerEvent);
        } else if (res[2]) { // zadan den a mesic
            const today = new Date();
            const dayBeforeMon = DateEdit._fmtOrder.indexOf("d") < DateEdit._fmtOrder.indexOf("m");
            if (dayBeforeMon) { // den pred mesicem
                this._formatDateAndSetValues(today.getFullYear(), +res[3], +res[2], triggerEvent);
            } else { // mesic pred dnem
                this._formatDateAndSetValues(today.getFullYear(), +res[2], +res[3], triggerEvent);
            }
        } else if (res[4]) { // zadan rok, mesic, den
            const y = DateEdit._fmtOrder.indexOf("y");
            const m = DateEdit._fmtOrder.indexOf("m");
            const d = DateEdit._fmtOrder.indexOf("d");
            const yr = res[y + 4].length === 2 ? "20" + res[y + 4] : res[y + 4]; // doplneni roku o 20
            this._formatDateAndSetValues(+yr, +res[m + 4], +res[d + 4], triggerEvent);
        }
    }

    // @ts-ignore // 23.4.2018 nevyužito, ale prozatím ponecháno
    private _parseValue(val: string): Date {
        const f_getDate = (year: number, mon: number, day: number): Date => {
            if (!DateEdit.checkDate(year, mon, day)) {
                return null;
            }

            return new Date(year, mon, day);
        };

        val = val.replace(/\u200E/g, ""); //Unicode Character 'LEFT-TO-RIGHT MARK' - je vlozen pred kazdym cislem po zavolanim Date.toLocaleString

        const rexes = DateEdit._getRexes(); // ziskani regexu
        const res: RegExpExecArray = rexes.noSep.exec(val) || rexes.sep.exec(val); // zkontrolovani data

        if (val && !res) { // nevalidni format data
            return null;
        }

        if (res[1]) { // zadan den
            const today = new Date();
            return f_getDate(today.getFullYear(), today.getMonth() + 1, +res[1]);
        } else if (res[2]) { // zadan den a mesic
            const today = new Date();
            const dayBeforeMon = DateEdit._fmtOrder.indexOf("d") < DateEdit._fmtOrder.indexOf("m");
            if (dayBeforeMon) { // den pred mesicem
                return f_getDate(today.getFullYear(), +res[3], +res[2]);
            } else { // mesic pred dnem
                return f_getDate(today.getFullYear(), +res[2], +res[3]);
            }
        } else if (res[4]) { // zadan rok, mesic, den
            const y = DateEdit._fmtOrder.indexOf("y");
            const m = DateEdit._fmtOrder.indexOf("m");
            const d = DateEdit._fmtOrder.indexOf("d");
            const yr = res[y + 4].length === 2 ? "20" + res[y + 4] : res[y + 4]; // doplneni roku o 20
            return f_getDate(+yr, +res[m + 4], +res[d + 4]);
        }

        return null;
    }

    // vrati regexy pro ziskani data
    private static _getRexes(): { noSep: RegExp; sep: RegExp } {
        if (DateEdit._fmtOrder.indexOf("y") === 2)
            return { noSep: DateEdit._noSepDmy, sep: DateEdit._sepDmy };
        else if (DateEdit._fmtOrder.indexOf("y") === 1)
            return { noSep: DateEdit._noSepDym, sep: DateEdit._sepDym };
        else
            return { noSep: DateEdit._noSepYmd, sep: DateEdit._sepYmd };
    }

    // propojeni mezi datepickerem/nativnim kalendarem a tel inputem. Bere format stejny jako fce formatDate
    private _formatDateAndSetValues(year: number, mon: number, day: number, userChange: boolean): boolean {
        if (!DateEdit.checkDate(year, mon, day)) {
            this._showError();
            return false;
        }

        const val = (year < 1000 ? "0" : "") + year + "-" + DateEdit._addZero(mon + "") + "-" + DateEdit._addZero(day + "");
        this._fakeInput.value = val;
        this._innerElement.value = DateEdit._formatDate(val);

        this.setValid();

        if (userChange)
            this.callEvent("change", undefined, false, true);
        //    this.ValueChanged.trigger(this, { Sender: this });

        return true;
    }

    // formatuje retezec (vzdy ve forme yyyy-m(m)-d(d) (napr. 2014-02-25 n. 2014-2-5))
    // vraci jej zformatovany podle aktualni kultury nebo prazdny, pokud format neni rozpoznan
    protected static _formatDate(date: string): string {
        if (!date)
            return "";

        return DateEdit._fmtFunc.format(new Date(date));
    }

    // zkontroluje, jestli zadany den/mesic/rok tvori platne datum
    public static checkDate(year: number, mon: number, day: number): boolean {
        const date = new Date(year, mon - 1, day);
        return date.getFullYear() === year && date.getMonth() === mon - 1 && date.getDate() === day;
    }

    // prida pocatecni nulu ke dni/mesici
    private static _addZero(val: string): string {
        if (val.length === 1)
            return "0" + val;
        return val;
    }

    private _showError(): void {
        this.setInvalid("VAL-102"); //Nemohli jsme rozpoznat zadane datum.
        this._fakeInput.value = ""; // kvuli GetControlValue() aby vratilo null
    }

    public setInnerElementID(id: string): void {
        this._innerElement.id = id;
    }

    protected override _createValuePicker(): HTMLElement {
        const picker = super._createValuePicker();
        Localization.addLocData(picker, "GUI-798917", ["title", "ariaLabel"]); // Výběr z kalendáře
        return picker;
    }
    //#endregion Methods

    //destruktor
    public override dispose(): void {
        if (this._fakeInput) {
            this._fakeInput.removeEventListener("change", this._listenerFakeChange);
            this._fakeInput.removeEventListener("focusin", this._listenerFakeFocus);
        }

        if (this._innerElement) {
            this._innerElement.removeEventListener("focus", this._listenerFocus);
            this._innerElement.removeEventListener("change", this._listenerChange);
        }

        if (this._calPicker) {
            this._calPicker.removeEventListener("click", this._listenerPickerClick);
        }

        super.dispose();
    }
}

registerCustomElement("tsc-dateedit", DateEdit);
